import  React from "react";
import { Typography, Link, useDialog, FlexGrid } from "@albo-ui/core";
import { ModalBlackListDialog } from "./ModalBlacklist";


export const ItemBlackList = ({ blacklistValidations, name }) => {
    const dialogProps = useDialog();
    const mached = blacklistValidations?.some(item => item.result === "matched");
    return <>
        <FlexGrid container>
            <Typography variant="paragraph" color="lightNeutral" style={{ width: "45%", paddingRight: 25 }}>
                {name}
            </Typography>
            <Link underlined style={{ display: "flex", alignItems: "center", width: "55%" }} onClick={dialogProps.openDialog} >
                {mached ? "Si" : "No"}
            </Link>
        </FlexGrid>
        <ModalBlackListDialog
            {...dialogProps}
            open={dialogProps.open}
            onClose={dialogProps.onClose}
            blackList={blacklistValidations} />
    </>
}
